import { Localized } from "@fluent/react"
import { Box, CircularProgress, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material"
import { useEffect, useState } from "react";
import { CopyToClipboardButton } from "../../../../app/components/CopyToClipboardButton";
import { CloseButton } from "../../../../app/components/CloseButton";
import { loadSysMailFooters, selectAllSysMailFooters, selectSysMailFooters } from "./sysMailFootersSlice";
import { DownloadButton } from "../../../../app/components/DownloadButton";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { If } from "../../../../app/If";

interface SysMailFootersGenerateCodeDialogProps {
    onCancel: () => void;
}

export const SysMailFootersGenerateCodeDialog: React.FC<SysMailFootersGenerateCodeDialogProps> = ({ onCancel }) => {
    const dispatch = useAppDispatch()
    const { state: sysMailFootersState } = useAppSelector(selectSysMailFooters)
    const sysMailFooters = useAppSelector(state => selectAllSysMailFooters(state))
    const [code, setCode] = useState("");

    const escapeSql = (text) => {
        if (!text) return '';
        return String(text).replace(/'/g, "''");
    };

    useEffect(() => {
        if (sysMailFootersState.type === "empty") {
            dispatch(loadSysMailFooters())
        } else {
            const inserts = sysMailFooters?.map(s => {
                const id = escapeSql(s.id);
                const footer = escapeSql(s.footer);
                const name = escapeSql(s.name);
                return `UPDATE [dbo].[SysMailFooters] SET Footer = '${footer}', IsDefault = ${s.isDefault ? 1 : 0} WHERE Id = '${id}';
                INSERT INTO [dbo].[SysMailFooters] ([Id], [Name], [Footer], [IsDefault], [ModifiedBy], [ModifyDate]) SELECT '${id}', '${name}', '${footer}', '${s.isDefault ? 1 : 0}', 'super', GETDATE() WHERE NOT EXISTS (SELECT 1 FROM [dbo].[SysMailFooters] WHERE Id = '${id}');`;
            }).join("\n\n");

            setCode(inserts ?? "");
        }
    }, [dispatch, sysMailFootersState, sysMailFooters])

    return (
        <>
            <DialogTitle>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Localized id="default-company-settings-generate-script">
                        <span>_Wygeneruj skrypt</span>
                    </Localized>
                    <div>
                        <DownloadButton name="migration_sysMailFooters" value={code} />
                        <CopyToClipboardButton value={code} />
                    </div>
                </Box>
            </DialogTitle>
            <DialogContent>
                <If condition={sysMailFootersState.type === "loaded"} otherwise={<CircularProgress/>}>
                    <Typography
                        component="pre"
                        sx={{
                            padding: 2,
                            fontFamily: "monospace"
                        }}
                    >
                    {`${code}`}
                    </Typography>
                </If>
            </DialogContent>
            <DialogActions>
                <CloseButton loading={false} onClick={onCancel} />
            </DialogActions>
        </>               
    )
}